import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import React, { useState } from "react"
import styled from "styled-components"
import { FONT_FAMILIES } from "../../../styles/Theme"

const Wrapper = styled.div`
  min-height: 300px;
`

const Content = styled.div`
  max-width: 900px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > * {
    height: 100%;
  }
  h2 {
    color: #3f007f;
    font-weight: normal;
    ${FONT_FAMILIES.rammetto};
    font-size: 1.8rem;
  }
  > :first-child {
    width: 100%;
    flex: 1;
    padding-right: 45px;
  }
  > :nth-child(2) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  @media (max-width: 930px) {
    padding-top: 30px;
    flex-direction: column-reverse;
    > :first-child {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
    }
  }
`

const Video = styled.div`
  position: relative;
  max-width: 400px;
  overflow: hidden;
  width: 100%;
  height: 225px;
  margin: auto auto;
  border-radius: 12px;
  > .gatsby-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  video {
    width: 100%;
  }
`

const Elements = styled.div``

const Element = styled.div`
  display: flex;
  align-items: center;
  > :first-child {
    margin-right: 10px;
  }
  img {
    height: 35px;
  }
`

interface IProps {
  title: string
  elements: {
    id: number
    image: any
    text: string
  }[]
  videoUrl: string
  thumbnail: any
}

const HowItWorks = (props: IProps) => {
  const { thumbnail, elements, videoUrl, title } = props
  const [videoDisplayed, setVideoDisplayed] = useState(false)

  return (
    <Wrapper>
      <Content>
        <div>
          <h2>{title || "How it works"}</h2>
          <Elements>
            {elements.map(e => (
              <Element key={e.id}>
                <img src={e.image.url} alt="" />
                <p>{e.text}</p>
              </Element>
            ))}
          </Elements>
        </div>
        <Video onClick={() => setVideoDisplayed(true)}>
          {videoDisplayed && (
            <video
              controls
              src={`${videoUrl}#t=0.1`}
              autoPlay={videoDisplayed}
              preload="metadata"
            />
          )}
          {!videoDisplayed && thumbnail && thumbnail.localFile && (
            <GatsbyImage
              image={getImage(thumbnail.localFile) as IGatsbyImageData}
              alt="How it works video thumbnail"
            />
          )}
        </Video>
      </Content>
    </Wrapper>
  )
}

export default HowItWorks
